import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-3xl mt-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        {/* Top: 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 mb-10 md:mb-14">
          {/* Column 1: Brand + Subscribe */}
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              Fique por Dentro
            </h3>
            <p className="text-background-50/50 text-sm leading-relaxed mb-6 max-w-sm">
              Receba as ultimas atualizacoes do <strong className="text-background-50/70">hoobuyspreadsheet</strong> e descubra novos produtos toda semana.
            </p>

            {/* Newsletter Form */}
            <form
              className="flex flex-col sm:flex-row gap-2 max-w-md"
              data-readdy-form="true"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const websiteAlt = formData.get('website_alt') as string;
                if (websiteAlt && websiteAlt.trim() !== '') {
                  const msg = document.createElement('div');
                  msg.className = 'text-accent-500 text-xs mt-2';
                  msg.textContent = 'Inscricao recebida! Verifique seu email.';
                  form.appendChild(msg);
                  setTimeout(() => msg.remove(), 3000);
                  return;
                }
                try {
                  const resp = await fetch('https://readdy.ai/api/form/d8ulvldu37m8lq7g36u0', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const msg = document.createElement('div');
                  msg.className = 'text-primary-400 text-xs mt-2';
                  msg.textContent = resp.ok ? 'Inscricao realizada com sucesso!' : 'Erro ao inscrever. Tente novamente.';
                  form.appendChild(msg);
                  setTimeout(() => msg.remove(), 3000);
                } catch {
                  const msg = document.createElement('div');
                  msg.className = 'text-accent-500 text-xs mt-2';
                  msg.textContent = 'Inscricao recebida! Verifique seu email.';
                  form.appendChild(msg);
                  setTimeout(() => msg.remove(), 3000);
                }
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Seu melhor email"
                required
                className="flex-1 bg-transparent border-b border-background-50/20 px-2 py-2.5 text-sm text-background-50 placeholder:text-background-50/30 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <button
                type="submit"
                className="px-6 py-2.5 bg-background-50 text-foreground-950 font-semibold text-sm rounded-full hover:bg-primary-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                Inscrever
                <i className="ri-arrow-right-line text-xs"></i>
              </button>
            </form>
          </div>

          {/* Column 2: Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50/80 mb-4">Links Rapidos</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/45 hover:text-background-50/80 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20">Inicio</Link>
              </li>
              <li>
                <Link to="/artigo/guia-completo-hoobuyspreadsheet" className="text-sm text-background-50/45 hover:text-background-50/80 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20">Guia Completo</Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/45 hover:text-background-50/80 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20 cursor-pointer">Kaspreadsheet</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Categories */}
          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50/80 mb-4">Categorias Populares</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/45 hover:text-background-50/80 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20 cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/35 hover:text-background-50/60 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20 cursor-pointer">
              hoobuy sheet
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/35 hover:text-background-50/60 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20 cursor-pointer">
              buy it now
            </a>
          </div>

          <p className="text-xs text-background-50/30 text-center whitespace-nowrap">
            &copy; {new Date().getFullYear()} HoobuySpreadsheet. Todos os direitos reservados.
          </p>

          <div className="flex items-center gap-4">
            <Link to="/" className="text-xs text-background-50/35 hover:text-background-50/60 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20">Privacidade</Link>
            <Link to="/" className="text-xs text-background-50/35 hover:text-background-50/60 transition-colors whitespace-nowrap border-b border-transparent hover:border-background-50/20">Termos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}